import React from 'react'
import PageHeader from '../../../shared/PageHeader'
import { FaEdit } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa6'
import EditClaimForm from '../visits/EditClaimForm'

function EditClaim () {
  const { t } = useTranslation()
  const location = useLocation()
  const editData = location?.state?.editData
  const navigate = useNavigate()
  return (
    <div className='main-page-container !overflow-y-auto scrollbar'>
      <PageHeader
        title={t('Edit Claim')}
        iconSize={20}
        Icon={FaArrowLeft}
        onIconClick={() => {
          navigate(-1)
        }}
      ></PageHeader>
      <div>
        <EditClaimForm editData={editData} />
      </div>
    </div>
  )
}

export default EditClaim
